import { AnyReportTemplate, GridDensity, ReportDataFilter, ReportOptionConfig, ReportTemplateTypes } from "@core/data/types/advanced-report";

export class InitReportGenerator {
    static readonly type = '[AdvancedReportState] Initialise Report Generator';
    constructor (public orgKey: string, public reportKey: string, public editMode: boolean = true, public shareKey: string = null) {}
}

export class LoadReportGenerator {
    static readonly type = '[AdvancedReportState] Loads Report Generator';
    constructor () {}
}

export class UpdateReportTitle {
    static readonly type = '[AdvancedReportState] Update Report Title';
    constructor (public title: string) {}
}

// Patches the report's filter into local state only — the filter dialog already persisted it
// server-side, so this just keeps the client in sync without a network round-trip.
export class SetReportFilter {
    static readonly type = '[AdvancedReportState] Set Report Filter';
    constructor (public reportKey: string, public filter: ReportDataFilter) {}
}

export class EditReportOptions {
    static readonly type = '[AdvancedReportState] Edit Report Options';
    constructor (public key: string, public reportKey: string, public config: ReportOptionConfig) {}
}

export class ChangeReportGridDensity {
    static readonly type = '[AdvancedReportState] Change Grid Density';
    constructor (public key: string, public reportKey: string, public density: GridDensity) {}
}

export class LoadReportSampleKeys {
    static readonly type = '[AdvancedReportState] Loads Report Data';
    constructor () {}
}

export class SetPageContext {
    static readonly type = '[AdvancedReportState] Set Page Context';
    constructor(public pageKeys: string[]) {}
}

export class AddReportPage {
    static readonly type = '[AdvancedReportState] Add Report Page';
    constructor() {}
}

export class RemoveReportPage {
    static readonly type = '[AdvancedReportState] Remove Report Page';
    constructor(public key: string) {}
}

export class AddReportPageOptions {
    static readonly type = '[AdvancedReportState] Add Page Options';
    constructor(
        public pageKey: string,
        public pageKeys: string[],
    ) {}
}

export class ToggleEditMode {
    static readonly type = '[AdvancedReportState] Toggle Edit Mode';
    constructor(public editMode: boolean) {}
}

export class ApplyReportTemplate {
    static readonly type = '[AdvancedReportState] Apply Report Template';
    constructor(public template: AnyReportTemplate) {}
}

export class ExtractReportTemplate {
    static readonly type = '[AdvancedReportState] Extract Report Template';
    constructor() {}
}

export class LoadReportTemplateOptions {
    static readonly type = '[AdvancedReportState] Load Template Options';
    constructor(public types: ReportTemplateTypes[] = [ReportTemplateTypes.REPORT]) {}
}